import { gql } from '@apollo/client';

export const FORGOT_PASSWORD = gql`
  mutation forgotPass($email: String!) {
    forgotPass(email: $email)
  }
`;
